// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 407) return "static/chunks/407.de904bb7c44dc535.js";
	if (chunkId === 966) return "static/chunks/64abf602.c5cb2ff9b4ecb7d3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 595 ? "e7910194" : chunkId) + "-" + {"379":"e9b78f6cb8a744fb","577":"afad019d0c5748a3","595":"a715d8c68d116db4"}[chunkId] + ".js";
};